import React, { useState, useEffect } from 'react';
import axios from 'axios';
import { PhoneCall, Check, RefreshCw } from 'lucide-react';
import { toast } from 'sonner';

const API_URL = process.env.REACT_APP_BACKEND_URL;

export default function RenewalCallsCard() {
  const [tasks, setTasks] = useState([]);
  const [running, setRunning] = useState(false);

  const load = () => axios.get(`${API_URL}/api/admin/renewal-calls`, { withCredentials: true })
    .then((r) => setTasks(r.data.tasks || [])).catch(() => {});
  useEffect(() => { load(); }, []);

  const done = async (id) => {
    await axios.put(`${API_URL}/api/admin/renewal-calls/${id}`, {}, { withCredentials: true });
    toast.success('Marked as called');
    load();
  };

  const runNow = async () => {
    setRunning(true);
    try {
      const { data } = await axios.post(`${API_URL}/api/admin/renewals/run`, {}, { withCredentials: true });
      toast.success(`Sent ${data.plan_emails + data.addon_emails} reminder(s), ${data.call_tasks} new call task(s)`);
      load();
    } catch {
      toast.error('Failed to run reminders');
    } finally {
      setRunning(false);
    }
  };

  return (
    <div className="bg-zinc-900/50 border border-zinc-800 rounded-xl p-6" data-testid="renewal-calls-card">
      <div className="flex items-center justify-between mb-4 gap-4">
        <div>
          <h3 className="text-lg font-bold flex items-center gap-2"><PhoneCall className="w-5 h-5 text-[#C41E3A]" /> Renewal calls</h3>
          <p className="text-sm text-zinc-500">Customers whose plan expires within a day and haven't renewed. Reminder emails go out automatically 15 and 3 days before.</p>
        </div>
        <button type="button" onClick={runNow} disabled={running} className="shrink-0 flex items-center gap-2 bg-zinc-800 hover:bg-zinc-700 text-zinc-200 px-3 py-2 rounded-lg text-sm disabled:opacity-50" data-testid="run-renewals-btn">
          <RefreshCw className={`w-4 h-4 ${running ? 'animate-spin' : ''}`} /> Run reminders now
        </button>
      </div>
      {tasks.length === 0 ? (
        <p className="text-zinc-500 text-sm" data-testid="renewal-calls-empty">No calls due right now.</p>
      ) : (
        <div className="divide-y divide-zinc-800">
          {tasks.map((t) => (
            <div key={t.id} className="py-3 flex items-center justify-between gap-4" data-testid={`renewal-call-${t.id}`}>
              <div>
                <p className="font-medium text-white">{t.company_name} <span className="text-zinc-500 text-sm font-normal">· {t.plan}</span></p>
                <p className="text-sm text-zinc-400">{t.name} · {t.phone ? <a href={`tel:${t.phone}`} className="text-[#C41E3A]">{t.phone}</a> : 'no phone'} · {t.email}</p>
                <p className="text-xs text-amber-400">Expires {new Date(t.expires_at).toLocaleDateString('en-IN', { day: 'numeric', month: 'short', year: 'numeric' })}</p>
              </div>
              <button type="button" onClick={() => done(t.id)} className="shrink-0 flex items-center gap-1 bg-emerald-600 hover:bg-emerald-700 text-white px-3 py-2 rounded-lg text-sm" data-testid={`renewal-call-done-${t.id}`}>
                <Check className="w-4 h-4" /> Called
              </button>
            </div>
          ))}
        </div>
      )}
    </div>
  );
}
